import { Box, styled } from '@mui/material';

export const LimitingWrapper = styled(Box)({
  maxWidth: '1700px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  padding: '0 100px',
  boxSizing: 'border-box',
});
